Backbone = require 'backbone'

class FAQAppRouter extends Backbone.Router
  routes:
    '' : 'renderFaq',
    ':id' : 'renderFaq'

  renderFaq : (id = "home") ->
    Groupon.FAQ.ViewManager.render(id)

module.exports = FAQAppRouter
